<template>
  <aside id="gnb" style="z-index: 10">
    <ul class="btn">
        <li v-for="(menu, index) in menuList" v-bind:key="index" :class="{'on': selectedTopMenuId === menu.mapSysNo}" >
          <a href="#" @click.prevent="clickTopMenu( menu.mapSysNo, menu.mapSysNm )"> {{menu.mapSysNm }}</a>
        </li>
    </ul>
    <div class="cnt" v-show="isShowMenu" style="overflow:scroll;">
        <!-- 통계분류 Start.. -->
        <h2 class="depth01-title">통계분류</h2>
        <div v-for="(menu, index) in menuList" v-bind:key="index">
          <ul v-for="(subMenu, subIndex) in menu.children" v-bind:key="subIndex" class="depth01" :class="{'on': selectedTopMenuId === menu.mapSysNo}"  >
            <li :part-title="subMenu.mapSysNm">
              <ul class="depth02-area">
                <li v-for="(statMenu, statMenuIndex) in subMenu.children" v-bind:key="statMenuIndex" :class="{'on': selectedStatMenuId === statMenu.mapSysNo}" >
                  <button type="button" class="tab_btn" @click.prevent="clickStatMenu( statMenu.mapSysNo, statMenu.mapSysNm, statMenu.srcCd, statMenu.srcNo )">{{ statMenu.mapSysNm }} </button>
                  <div class="depth02">

                    <!-- 통계표 항목 Start.. -->
                    <h3 class="depth02-title">항목목록</h3>
                    <ul>
                      <li v-for="(statItem, statItemIndex) in statItemList" v-bind:key="statItemIndex" >
                        <div class="checkbox">
                          <input type='checkbox' v-bind:id="statItem.mapItmNo" v-bind:value="statItem" v-model="selectedStatItemList" @change="selectStatMenu(statItem, $event)">
                          <label v-bind:for="statItem.mapItmNo">{{ statItem.mapItmOutNm }}</label>
                        </div>
                      </li>
                    </ul>
                    <!-- 통계표 항목 End.. -->
                    <!-- 통계표 항목 Start.. -->
                    <h3 class="depth02-title">해당 연도</h3>
                    <ul>
                      <li v-for="(statYearItem, statItemYearIndex) in statItemYearList" v-bind:key="statItemYearIndex" >
                        <div class="checkbox">
                          <input type='checkbox' v-bind:id="statYearItem.year" v-bind:value="statYearItem.year" v-model="selectedStatItemYearList" @change="selectStatYear()">
                          <label v-bind:for="statYearItem.year">{{ statYearItem.year }}년</label>
                        </div>
                      </li>
                    </ul>
                    <!-- 통계표 항목 End.. -->

                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!-- 통계분류 End.. -->
    </div>
    <button type="butotn" id="menuToggle" class="menu-toggle" title="통계분류 숨김 버튼"
        @click.prevent="clickMenuToggle()">통계분류 숨김 버튼</button>
  </aside>
</template>

<script>
import { mapActions } from 'vuex'
import { eventBus } from '@/event-bus'

export default {
  name: 'Menu',

  data () {
    return {
      menuList: null,
      statItemList: [],
      statItemYearList: [],
      selectedTopMenuId: '',
      selectedStatMenuId: '',
      selectedStatMenuName: '',
      selectedStatSrcCd: '',
      selectedStatSrcNo: '',
      selectedStatItemList: [],
      selectedStatItemYearList: [],
      isShowStatMenuLocation: true,
      isShowMenu: true
    }
  },

  created () {
    this.searchMenu()
    eventBus.$on('sendCloseStatItem', (closeStatItm) => {
      for (let idx = 0; idx < this.selectedStatItemList.length; idx++) {
        const statItem = this.selectedStatItemList[idx]
        if (statItem.mapItmNo === closeStatItm.mapItmNo) {
          this.selectedStatItemList.splice(idx, 1)

          this.selectStatMenu(statItem)
        }
      }
    })
  },

  methods: {
    ...mapActions({
      addStatItem: 'addStatItem',
      removeStatItem: 'removeStatItem',
      setStatItemYearList: 'setStatItemYearList'
    }),

    // 메뉴 조회
    searchMenu () {
      this.$axios.get('/portal/menus').then(res => {
        this.menuList = res.data

        if (this.menuList.length > 0) {
          this.selectedTopMenuId = this.menuList[0].mapSysNo
        }
      })
    },

    // 통계분류에 해당하는 항목 조회
    searchStatItem (mapSysNo) {
      this.$axios.get('/portal/menus/items/' + mapSysNo).then(res => {
        this.statItemList = res.data
      })
    },

    // 통계분류 항목에 해당 연도 목로고 조회
    searchStatItemYear (mapSysNo) {
      this.$axios.get('/portal/menus/items/years/' + mapSysNo).then(res => {
        this.statItemYearList = res.data
        this.selectedStatItemYearList = []

        const selectedStatItems = this.$store.getters.selectedStatItems
        for (const selectedStatItem of selectedStatItems) {
          if (this.selectedStatMenuId === selectedStatItem.mapSysNo) {
            this.selectedStatItemYearList = selectedStatItem.years
          }
        }
      })
    },

    // 메뉴 클릭 이벤트
    clickTopMenu (mapSysNo, menuName) {
      this.isShowMenu = true
      this.selectedTopMenuId = mapSysNo
      this.selectedStatMenuId = ''
      this.selectedStatMenuName = ''
      this.selectedStatSrcCd = ''
      this.selectedStatSrcNo = ''

      this.showMenuToggleLocation(true)
    },

    // 통계분류 메뉴 클릭 이벤트
    clickStatMenu (mapSysNo, menuName, srcCd, srcNo) {
      this.selectedStatMenuId = mapSysNo
      this.selectedStatMenuName = menuName

      if (!srcNo) {
        this.selectedStatSrcCd = ''
        this.selectedStatSrcNo = ''
      } else {
        this.selectedStatSrcCd = srcCd
        this.selectedStatSrcNo = srcNo
      }

      this.showMenuToggleLocation(false)
      this.searchStatItem(mapSysNo)
      this.searchStatItemYear(this.selectedStatMenuId)
    },

    selectStatMenu (statItem, $event) {
      if (this.selectedStatItemList.length > this.$store.getters.statItemMaxCount) {
        this.selectedStatItemList.splice(this.selectedStatItemList.length - 1, 1)
        $event.target.checked = false
        alert('최대 3개까지만 선택이 가능 합니다.')
      } else {
        const findItem = this.$store.getters.findStatItem(statItem.mapItmNo)
        if (findItem) {
          this.removeStatItem({ info: statItem })
        } else {
          if (this.selectedStatItemList.length <= this.$store.getters.statItemMaxCount) {
            this.addStatItem({
              mapSysNo: this.selectedStatMenuId,
              mapSysNm: this.selectedStatMenuName,
              srcCd: this.selectedStatSrcCd,
              srcNo: this.selectedStatSrcNo,
              info: statItem,
              years: this.selectedStatItemYearList
            })
          }
        }

        this.searchStatItemYear(this.selectedStatMenuId)
      }
    },

    selectStatYear () {
      this.setStatItemYearList({
        mapSysNo: this.selectedStatMenuId,
        yearList: this.selectedStatItemYearList
      })
    },

    // 메뉴바 토글 이벤트 설정
    showMenuToggleLocation (isShowStatMenuLocation) {
      this.isShowStatMenuLocation = isShowStatMenuLocation

      document.getElementById('menuToggle').classList.remove('off')

      if (this.isShowStatMenuLocation) {
        document.getElementById('menuToggle').style.left = '431px'
      } else {
        document.getElementById('menuToggle').style.left = '710px'
      }
    },

    clickMenuToggle () {
      this.isShowMenu = !this.isShowMenu

      if (this.isShowMenu) {
        document.getElementById('menuToggle').classList.remove('off')
        this.showMenuToggleLocation(this.isShowStatMenuLocation)
      } else {
        document.getElementById('menuToggle').classList.add('off')
        document.getElementById('menuToggle').style.left = '110px'
      }
    }
  }
}
</script>

<style>
</style>
